import React from 'react';
import {
  InputTextarea,
  type InputTextareaProps,
} from 'primereact/inputtextarea';
import classNames from 'classnames';

interface IMyInputTextAreaProps extends InputTextareaProps {
  label: string;
  className?: string;
  inputClassName?: string;
}

export default function MyInputTextArea({
  label,
  className,
  inputClassName,
  ...props
}: IMyInputTextAreaProps) {
  return (
    <div className={classNames('relative flex flex-col', className)}>
      <label className="flex absolute ml-4 mt-[-0.75rem] px-1 text-base rounded-lg bg-neutral-100">
        {label}
      </label>
      <InputTextarea
        {...props}
        className={classNames('py-5', inputClassName)}
      />

      {props.maxLength && (
        <div className="self-end mt-2 text-sm">
          {props.value?.length ?? 0}/{props.maxLength}
        </div>
      )}
    </div>
  );
}
